export const AUTH_TOKEN = 'auth_token'
export const ADMIN_TOKEN = 'admin_token'
export const IS_IMPERSONATING = 'is_impersonating'